import { jsx as _jsx } from "react/jsx-runtime";
import { PageButton } from '../PageButton';
export function PageNumberButton({ page, onClick, hrefFormatter, activated, setButtonRef }) {
    const handleClick = (event) => onClick(page, event);
    const formattedHref = hrefFormatter && hrefFormatter(page);
    return (_jsx(PageButton, { label: page, onClick: handleClick, activated: activated, "aria-current": activated ? 'page' : undefined, "data-test-id": `page-number-button-${page}`, setButtonRef: setButtonRef, href: formattedHref }));
}
